import styled, { css } from "styled-components";


export const AccountConfimationContainer = styled.div<{ open: boolean }>`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.colors.primaryPurple.main};
    ${({ open }) => open
    ? css`
        height: 100%;
        padding: 0.5rem 0;
    `
    : css`
        height: 0;
        padding: 0;
    `}
    transition: all 0.5s;
`;

export const MessageContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;
`;

